import { render } from "./Default.vue?vue&type=template&id=c0701bd6&ts=true"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__